import React from 'react';

const Who = () => {
  return (
    <div>
      <h1>Who We Are</h1>
      <section className="card mission-card">
      <h2>Our Mission</h2>
      <p>
        At Legacy Motors, our mission is to deliver unparalleled automotive services while building lasting relationships with our customers through integrity, quality, and innovation.
      </p>
      </section>
    </div>
  );
};

export default Who;